import React from "react";
import { Typography } from "@mui/material";

const fontSizeDefault = {
  xs: "0.85rem", // スマホサイズ（xs = extra small）: ~600px
  sm: "1.0rem", // タブレット: 600px〜
  md: "1.1rem", // PCサイズ: 900px〜
};

const Sentence = ({
  children,
  size = fontSizeDefault,
  paragraph = true,
  sx = {},
}) => {
  return (
    <Typography
      paragraph={paragraph}
      className="koku-gothic-text"
      sx={{
        // fontFamily: 'sans-serif',
        fontFamily: "'KokuGothic', sans-serif",
        lineHeight: 1.8, // 行間のデフォルト値を設定
        fontSize: size,
        ...sx, // 他のスタイルを上書き
      }}
    >
      {children}
    </Typography>
  );
};

export default Sentence;
